<ng-container *ngIf="loggedUser$ | async as user">
  <app-profile-card
    [user]="user"
    (uploadFile)="onUploadFile($event)"
  ></app-profile-card>
</ng-container>
